import React, { useState } from 'react';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';
import InstitutionalClassificationWheel from './InstitutionalClassificationWheel';


export default function InstitutionalClassification({ institutionData, updateTab }) {

    return (
        <Widget className="institutional-classification background-white">
            <div className="row" style={{ minHeight: '225px' }}>
                <div className='d-flex justify-content-center p-3'>
                    <InstitutionalClassificationWheel institutionData={institutionData} />
                </div>
            </div>
            <div className="row border-top pt-3 px-3">
                <div className="col-9">
                    <WidgetTitle>Institutional Classification</WidgetTitle>
                </div>
                <div className="col-3">
                    <div className="d-flex justify-content-end">
                        <a href="#" onClick={(e) => updateTab('institutional')}>
                            <div className="circle-chev">
                                <img src="/wp-content/uploads/2023/01/arrow-right.svg" alt="" />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div className="row px-3">
                <div className="col-12">
                    {institutionData.post_meta.ic2025.label}
                </div>
            </div>
        </Widget >
    );
}